import type { OsasExternalReferralLetterData } from '@common/validation/customControls/osas/osasExternalReferralLetterSchema';
import { ProcessActivityAssetsRead } from '@frontend/components/pages/episodeCategory/customControls/processActivityAssets/ProcessActivityAssetsRead';
import { getSelectedLanguage } from '@frontend/translate';
import { useProcessActivityReadContext } from '@frontend/utils';

export function OsasExternalReferralLetterRead(): JSX.Element {
    const { processActivity } = useProcessActivityReadContext<OsasExternalReferralLetterData>();
    const translate = getSelectedLanguage();
    const { customControlData } = processActivity;

    return (
        <>
            {customControlData.assets.length > 0 && (
                <ProcessActivityAssetsRead
                    assets={customControlData.assets}
                    label={translate.diagnosticReport.attachment}
                />
            )}
        </>
    );
}
